<template>
  <div class="picmanger">
    <!-- <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt="">
        <el-breadcrumb separator="/">

          <el-breadcrumb-item>创建推送</el-breadcrumb-item>

        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img width="16px" height="16px" src="@/assets/house/refresh.png" alt="">
        <p>刷新</p>
      </div>
    </div> -->

    <div class="main">
      <div class="head">
        <h4>推送至：{{$route.query.name}}</h4>
      </div>
      <div class="tablebg">
        <div style="width:calc(100% - 300px);margin:0 auto;padding:20px;">
          <allpushform @closeForm="closeForm"
                       @submitForm="submitForm"></allpushform>

          <!-- <el-button @click="dialogFormVisible = true">弹框表单</el-button> -->
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { allpushform } from '@/components/index'
import { addPicturePackage } from "@/api/picturePackage";
import { setUserSetting } from '@/api/config'
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    'allpushform': allpushform
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {

    };
  },
  methods: {
    ...mapActions(["setLoveList"]),

    closeForm () {
      this.$router.push('/desktop/contributor')
    },

    submitForm (val, choosePic) {
      let content = {
        text: val.content,
        images: []
      }
      for (let j = 0; j < choosePic.length; j++) {
        let imgInfo = {
          fid: '',
          path: '',
          desc: ''
        }
        imgInfo.fid = choosePic[j].id
        imgInfo.path = choosePic[j].src
        imgInfo.desc = choosePic[j].desc
        content.images.push(imgInfo)
      }

      let pushConfig = {
        pushChannelId: this.$route.query.pushChannelId,
        content: content,
        intitle: val.intitle,
        author: val.author,
        source: val.source,
        subtitle: val.subtitle,
        title: val.title
      }

      let choosePicMsg = {
        createUid: this.createUid,
        packageType: "push",
        pictureCount: choosePic.length,
        pictureIds: '',
        title: val.title,
        pushConfig: JSON.stringify(pushConfig)
      }

      for (let i = 0; i < choosePic.length; i++) {
        if (i === choosePic.length - 1) {
          choosePicMsg.pictureIds += choosePic[i].id
        } else {
          choosePicMsg.pictureIds += choosePic[i].id + ','
        }
      }
      this.addPicturePackageAsync(choosePicMsg)
      if (this.$route.query.isSavePic == 'false') {
        if(this.$route.query.isDrawer == 'false'){
          let allLovePic = JSON.parse(sessionStorage.getItem("picLove"));
          let chooseLovePic = JSON.parse(sessionStorage.getItem("chooseArr"));
          let nowLovePic = allLovePic
          for (let i = 0; i < allLovePic.length; i++) {
            for (let j = 0; j < chooseLovePic.length; j++) {
              if(chooseLovePic[j].id == allLovePic[i].id){
                nowLovePic.splice(i,1)
              }
            }
          }
          let idsInfo = []
          for (let k = 0; k < nowLovePic.length; k++) {
            idsInfo.push({
              id: nowLovePic[k].id,
            })
          }
          this.setLoveList(nowLovePic)
          sessionStorage.setItem("picLove", JSON.stringify(nowLovePic));
          this.setUserSettingAsync(this.createUid, 'picLove', { value: idsInfo })
        }else{
          let loveList = []
          this.setLoveList(loveList)
          sessionStorage.removeItem("picLove");
          this.setUserSettingAsync(this.createUid, 'picLove', { value: null })
        }
        
      }
      setTimeout(() => {
        this.$router.push('/shareAndPush/myPush')
      }, 1500);
    },

    //设置选用图片
    async setUserSettingAsync (val, val2, data1) {
      let { status, data, message, errors } = await setUserSetting(val, val2, data1);
      if (status) {
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //增加图片包

    async addPicturePackageAsync (val) {
      let { status, data, message, errors } = await addPicturePackage(val);
      if (status) {
        this.$message.success("添加成功！");

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },


  },
  created () {

  },
  mounted () {

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./allpush.scss";

h4 {
  font-size: 18px;
}
</style>
